/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
// 点淘App Hybrid：https://yuque.antfin-inc.com/ya8qsr/vzgrmn/gnivzc?#
function showSharePanel(params, context) {
    context.WVCall('TBSharedModule.showSharedMenu', params);
}

export { showSharePanel as default };
